export const meetings = {
  attendance: {
    title: 'Confirmed attendance',
    hint: 'Anyone who joins the video call is marked as attending. Super admins can override the list.',
    empty: 'No one confirmed yet — start or join the call to record attendance.',
    override: 'Override attendance',
    overrideLabel: 'Confirmed attendees',
    cancel: 'Cancel',
    save: 'Save attendance',
  },
  call: {
    title: 'Video call',
    linkedGroup: 'Linked to {{name}}',
    openChat: 'Open team chat',
    noGroup: 'Link a Team Updates group when scheduling the meeting to start a video call here.',
  },
  actions: {
    confirmToChat: 'Confirm actions to team chat',
    confirmToChatHint: 'Posts action points to the linked Team Updates group.',
    confirmedAt: 'Last posted to team chat {{date}}',
    needsGroup: 'Link a Team Updates group to post actions to chat',
    needsActions: 'Add at least one action point before confirming',
    postedSuccess: 'Action points posted to team chat',
  },
  form: {
    teamGroup: 'Team Updates group',
    teamGroupHint: 'Optional. Links the meeting to an existing chat for video calls and action posts. Members are added as invitees.',
    teamGroupPlaceholder: 'Select a team chat',
    clearGroup: 'No group',
  },
  calendar: {
    add: 'Add to Overhear calendar',
    update: 'Update on Overhear calendar',
    open: 'Open in Google Calendar',
    tooltip: 'Adds this meeting to the shared Overhear Gmail calendar. You do not need to be signed into that account.',
    updateTooltip: 'Updates the existing Overhear calendar event with the saved meeting details.',
    openTooltip:
      'Opens this event on the Overhear Gmail calendar (hello@theoverhear.app). Google may ask you to choose that account.',
    selectMeeting: 'Select a meeting to add it to the Overhear calendar',
    noDate: 'This meeting has no scheduled date',
    added: 'Meeting added to the Overhear calendar',
    updated: 'Overhear calendar event updated',
  },
  detail: {
    minutes: 'Minutes',
    emailAgenda: 'Email agenda',
    resendAgenda: 'Resend agenda',
    emailAgendaNoRecipients:
      'No attendee email addresses found — add platform admins or guest attendees with emails.',
    publishMinutes: 'Publish minutes',
    republishMinutes: 'Republish minutes',
    viewMinutes: 'View minutes',
    publishRequiresCompleted:
      'Set the meeting status to Completed before publishing minutes',
    publishMinutesTooltip: 'Publish the meeting minutes',
    republishMinutesTooltip: 'Republish the meeting minutes',
    unsavedHint: 'You have unsaved changes',
    unsavedSettledHint:
      'You have unsaved changes. Saving will update paid work / project accruals to match the new section times.',
    saved: 'Meeting saved',
    savedWithAccrualSync: 'Meeting saved and accruals updated',
    settledSuccess: 'Meeting accruals settled',
    unsettledSuccess:
      'Meeting unsettled — paid work charges, project accruals, and tracker expenses removed',
    unsettleConfirm:
      'Unsettle this meeting? This restores paid work pool hours and removes paid work charges, project accrual lines, and matching budget-tracker expenses.',
    settleAccruals: 'Settle paid work / project accruals',
    unsettleAccruals: 'Unsettle accruals',
  },
};

export type MeetingsTranslations = typeof meetings;
